import "../scss/style.scss";

// Modules / classes
import initStickyTableHeaders from "./modules/stickyTables";

// Instantiate new instances of classes
const nbswiper = new Swiper('.swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    // breakpoints
    breakpoints: {
        512: {
        slidesPerView: 2,
        spaceBetween: 20,
        },
        896: {
        slidesPerView: 3,
        spaceBetween: 40,
        },
        1248: {
        slidesPerView: 4,
        spaceBetween: 50,
        },
    },
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: false
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    }
});

// initiate sticky tables
initStickyTableHeaders({
    headerSelector: ".mega-menu-wrap",
    fadePx: 16, // smoother/longer fade
    // bottomBufferPx: 4 // extra hysteresis if needed
});